import {GOBLINS_TRAP_MAX_DAMAGE, GOBLINS_TRAP_MIN_DAMAGE} from "../../configs/factions/goblins";

// Урон одной сработавшей ловушки Гоблинов — случайное целое число в диапазоне
// [GOBLINS_TRAP_MIN_DAMAGE, GOBLINS_TRAP_MAX_DAMAGE] (1-3). Это не бросок
// успеха (как getD6Roll/getD20Roll), а сразу диапазон урона, поэтому нет
// параметра minRoll для подкрутки ботов — фракция исключена из пула ботов
export const getGoblinsTrapDamageRoll = () => {
  return GOBLINS_TRAP_MIN_DAMAGE + Math.floor(Math.random() * (GOBLINS_TRAP_MAX_DAMAGE - GOBLINS_TRAP_MIN_DAMAGE + 1));
}
